/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_filter_dropdown_no_lang20 = /** @type {(inputs: {}) => string} */ () => {
	return `No language filter…`
};

const fr_filter_dropdown_no_lang20 = /** @type {(inputs: {}) => string} */ () => {
	return `Pas de filtre de langue…`
};

const de_filter_dropdown_no_lang20 = /** @type {(inputs: {}) => string} */ () => {
	return `Kein Sprachfilter…`
};

const es_filter_dropdown_no_lang20 = /** @type {(inputs: {}) => string} */ () => {
	return `Sin filtro de idioma…`
};

const it_filter_dropdown_no_lang20 = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun filtro linguistico…`
};

const ar_filter_dropdown_no_lang20 = /** @type {(inputs: {}) => string} */ () => {
	return `لا يوجد فلتر لغوي…`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const filter_dropdown_no_lang20 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.filter_dropdown_no_lang20(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("filter_dropdown_no_lang20", locale)
	if (locale === "en") return en_filter_dropdown_no_lang20(inputs)
	if (locale === "fr") return fr_filter_dropdown_no_lang20(inputs)
	if (locale === "de") return de_filter_dropdown_no_lang20(inputs)
	if (locale === "es") return es_filter_dropdown_no_lang20(inputs)
	if (locale === "it") return it_filter_dropdown_no_lang20(inputs)
	return ar_filter_dropdown_no_lang20(inputs)
};
export { filter_dropdown_no_lang20 as "FILTER_DROPDOWN_NO_LANG" }